import PropTypes from 'prop-types'

export default function H3TitleLeftAlign({title, className, ...props}) {
  return (
    <h3 className={`text-left ${className ? className : ''}`} {...props}>{title}</h3>
  )
}

H3TitleLeftAlign.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
}